import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4l3jg0ght8: FaireBrandEntity = {
  token: "b_4l3jg0ght8",
  type: "brand",
  name: "Silkberry Baby",
  avatarUrl:
    "https://cdn.faire.com/fastly/8029cab068d2166a4fafdbc1b65fd754d0cdeb52b418ac80c9e42c1293ced6e7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/04d7e4eef0b801a522556a0a210c8723b5d5f311fd90a260b8cbaaf20010829f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8029cab068d2166a4fafdbc1b65fd754d0cdeb52b418ac80c9e42c1293ced6e7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/04d7e4eef0b801a522556a0a210c8723b5d5f311fd90a260b8cbaaf20010829f.jpeg",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 66,
  isInsider: false,
  description:
    "Silkberry Baby® is designed by moms for our little citizens. With eco-conscious parents in mind, we use certified sustainable fabric (organic cotton and bamboo rayon). Our goal is always to design clothing that is functional and stylish. We think children’s clothes should be easy to play, run, skip, tumble, snuggle and nap in. Our latest collections for bamboo rayon jersey, bamboo fleece and organic cotton offer super softness and thoughtful design details to make life easier for parents and kids alike. We hope you love these styles, colors and prints as much as we do! \nFor shipments to the USA, we are responsible for all import fees, including customs clearance fees, tariffs/duties, and applicable taxes. This ensures a no-hassle experience for U.S. customers, with no tariffs or fees charged to your account.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:25.573Z",
    importedBy: "entity-db-cli",
  },
};
